type WorkflowSettings = {
  user_policy?: {
    is_workflow_admin?: boolean
  }
}

export function isWorkflowAdminFromSettings(
  settings: WorkflowSettings | null | undefined
): boolean {
  return settings?.user_policy?.is_workflow_admin ?? false
}
